import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    card: {
        background: `${theme.palette.primary.main} !important`,
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15) !important",
        borderRadius: "4px !important",
        "&::before": {
            content: "none !important",
        },
        "& .Mui-expanded": {
            minHeight: "0 !important",
        },
    },
    cardHeader: {
        padding: "12px 22px !important",
        display: "flex !important",
        borderBottom: `1px solid ${theme.palette.border.select} !important`,
        "& .MuiAccordionSummary-content": {
            alignItems: "center !important",
            margin: "0 !important",
            gap: 8,
        },
    },
    cardTitle: {
        fontSize: 18,
        fontWeight: 400,
        fontFamily: "Open Sans",
        color: theme.palette.info.main,
    },
    cardBody: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
    },
    cardBodyContent: {
        padding: "14px 14px 4px 14px",
        display: "flex",
        flexWrap: "wrap",
        gap: 14,
    },
    cardAlert: {
        padding: "0px 16px !important",
    },
    cardHeaderIcon: {
        transition: "all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    },
}));
